import React, { useId } from "react";
import { KeyStatisticFigure, SectionHeader } from "../../molecules";
import { Container, EntryAnimation } from "../../atoms";
export default function KeyFiguresSection(param) {
    var title = param.title, subtitle = param.subtitle, figures = param.figures, className = param.className;
    var id = useId();
    return /*#__PURE__*/ React.createElement(Container, {
        name: KeyFiguresSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "text-center max-w-sm mx-auto mb-6 md:mb-8"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-flow-row auto-rows-max grid-cols-2 gap-x-6 gap-y-7 md:gap-y-11 md:grid-cols-3"
    }, figures.map(function(fig, figIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "fig-".concat(id, "-").concat(fig.label),
            delay: figIndex / 10
        }, /*#__PURE__*/ React.createElement(KeyStatisticFigure, fig));
    })));
}

//# sourceMappingURL=KeyFiguresSection.js.map